import { Button, Modal } from "@salesapp/ui";
import type { LossReasonOption } from "../../lib/crmApi";

export function CloseLostModal({
  open,
  reasons,
  selectedCodes,
  onToggleCode,
  comment,
  onCommentChange,
  onCancel,
  onConfirm,
  saving = false,
}: {
  open: boolean;
  reasons: LossReasonOption[];
  selectedCodes: string[];
  onToggleCode: (code: string) => void;
  comment: string;
  onCommentChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  saving?: boolean;
}) {
  const canConfirm = selectedCodes.length > 0 && comment.trim().length > 0 && !saving;
  return (
    <Modal
      isOpen={open}
      onClose={onCancel}
      title="Close this deal as lost"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>Cancel</Button>
          <Button onClick={onConfirm} disabled={!canConfirm}>
            {saving ? "Saving…" : "Close as lost"}
          </Button>
        </>
      }
    >
      <p className="crm-help">
        Select at least one reason and add a comment so the team can trend why deals are lost.
      </p>
      <fieldset className="crm-loss-reason-list">
        <legend className="crm-field">Loss reason(s)</legend>
        {reasons.map((reason) => (
          <label key={reason.code} className="crm-loss-reason-item" title={reason.description || undefined}>
            <input
              type="checkbox"
              checked={selectedCodes.includes(reason.code)}
              onChange={() => onToggleCode(reason.code)}
            />
            {reason.label}
          </label>
        ))}
      </fieldset>
      <div className="crm-resizable-field">
        <label className="crm-field" htmlFor="close-lost-comment">Comment</label>
        <div className="crm-resizable-field-shell">
          <textarea
            id="close-lost-comment"
            value={comment}
            onChange={(event) => onCommentChange(event.target.value)}
            placeholder="Why is this deal closed lost?"
            required
          />
        </div>
      </div>
    </Modal>
  );
}
